import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IPromotionLookup } from 'src/common/interfaces/dtos/IPromotionLookup';
import { IPromotionsLookupDto } from 'src/common/interfaces/dtos/IPromotionsLookupDto';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';

export const promotionsLookup = async (data: IPromotionsLookupDto): Promise<IPromotionLookup[]> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/promotions-management/promotions/lookup`,
    method: 'POST',
    data: data,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoggingInfo: true,
    spanOptions: { name: 'promotions-lookup' },
  };
  const response = await emeraldRequest<IPromotionLookup[]>(emeraldRequestParams);
  return response;
};
